import { useState, useCallback } from 'react';
import {
  getSuggestedDosages,
  saveSuggestedDosage,
  deleteSuggestedDosage,
  clearSuggestedDosages
} from '../../../utils/storage/suggestedDosages';
import type { SuggestedDosage } from '../../../types/data';

export const useDosageStorage = () => {
  const [dosages, setDosages] = useState<SuggestedDosage[]>(getSuggestedDosages());

  const refreshDosages = useCallback(() => {
    setDosages(getSuggestedDosages());
  }, []);

  const saveDosage = useCallback((dosage: SuggestedDosage) => {
    saveSuggestedDosage(dosage);
    refreshDosages();
  }, [refreshDosages]);

  const deleteDosage = useCallback((id: string) => {
    deleteSuggestedDosage(id);
    refreshDosages();
  }, [refreshDosages]);

  const clearDosages = useCallback(() => {
    clearSuggestedDosages();
    refreshDosages();
  }, [refreshDosages]);

  return {
    dosages,
    saveDosage,
    deleteDosage,
    clearDosages,
    refreshDosages
  };
};